import axios from 'axios';

const API_URL = 'https://api.paragaia.tn/subcategory';

export const getAllSubcategories = () => {
  return axios.get(API_URL);
};

export const getSubcategoryById = (id) => {
  return axios.get(`${API_URL}/${id}`);
};

export const getSubcategoriesByCategory = (categoryId) => {
  return axios.get(`${API_URL}/by-category/${categoryId}`);
};

export const getCategoryOfSubcategory = (subcategoryId) => {
  return axios.get(`${API_URL}/category-of/${subcategoryId}`);
};
